
export const WCL_URL = 'https://wcl.axcient.com/v0.58.2';
